<template>
  <div class="home pt-16 text--secondary">
    <v-container>
      <v-row class="text-center mt-10">
        <v-col>
          <h2 class="text-h2 mb-3 mt-8">{{ title }}</h2>
        </v-col>
      </v-row>

      <div class="text-center mt-5">
        <h4 class="mt-3 mb-5 text-h4 font-weight-light" style="line-height: 3rem">{{ message }}</h4>
      </div>

      <div class="py-3 text-center">
        Per ricevere assistenza scrivi a <a href="mailto:assistenza@istattms.it">assistenza@istattms.it</a>
      </div>
    </v-container>
  </div>
</template>

<script>
// Component
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
  },
}
</script>
